import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchCharityListData } from '../../services/api';
import { submitCharityDonation } from '../../services/api';
import '../../styles/output.css';
import '../../styles/index.css';
import { SideMenu, Header, TopMenu } from 'maxcu-shared-lib';
import menuItems from '../SideMenu/menuItems';

function DonateCharityList() {
    const [charityData, setCharityData] = useState(null);
    const [error, setError] = useState(null);
    const [points, setPoints] = useState('');
    const [selectedCharity, setSelectedCharity] = useState('');
    const [message, setMessage] = useState({ type: '', text: '' });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [memberNumber, setMemberNumber] = useState('');
    const navigate = useNavigate();
    const [isCollapsed, setIsCollapsed] = useState(false);
    
    useEffect(() => {
      let isMounted = true;
      document.title = "Donate Member Rewards to Charity | MAX Credit Union";
  
      const getData = async () => {
        try {
          const result = await fetchCharityListData();
          setTimeout(() => {
            if (isMounted){
              setCharityData(result);
              setMemberNumber(result.member_number);
            }
          },1000);
          
        } catch (err) {
          if (isMounted){
            setError(err);
          }
        }
      };
      getData();

      const handleResize = () => {
        if (window.innerWidth < 600) {
            setIsCollapsed(true);
        } else {
            setIsCollapsed(false);
        }
        };

        handleResize(); // Set initial state

        window.addEventListener('resize', handleResize);
        
        return () => {
            isMounted=false;
            window.removeEventListener('resize', handleResize);
        };
    }, []);
  
    if (error) return <div>Error: {error.message}</div>;
    if (!charityData) return <div className='text-center'>Loading...</div>;
    const minValue = 500;
    
    const isFormValid = () => {
        return selectedCharity !== '' && parseInt(points) >= minValue;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ type: '', text: '' });
        
        try {
            const response = await submitCharityDonation({
                charityId: selectedCharity,
                points: points,
                member_number: memberNumber
            });
            
            // Check response for success/failure
            if (response.donate_status === '200') { // Adjust this condition based on your API response
                setMessage({
                    type: 'success',
                    text: 'Your donation was successful! Thank you for your generosity.'
                });
                setIsSubmitted(true);
                setPoints('');
                setSelectedCharity('');
            } else {
                setMessage({
                    type: 'error',
                    text: response.donate_status || 'Donation could not be processed. Please try again.'
                });
            }
            
        } catch (error) {
            console.error('Error submitting donation:', error);
            setMessage({
                type: 'error',
                text: 'An error occurred while processing your donation. Please try again.'
            });
        }
    };

    const handleReset = () => {
        setIsSubmitted(false);
        setMessage({ type: '', text: '' });
        setPoints('');
        setSelectedCharity('');
    };

  return (
    <div style={{ display: 'flex' }}>
      <SideMenu menuItems={menuItems} />
      <div style={{ flex: 1 }} className={`${isCollapsed ? 'sb-thin' : 'sb-wide'}`}>
      <Header name="Donate Points" />
      {isCollapsed && <TopMenu />}
      <div className="mx-auto md:max-w-3xl md:grid md:grid-cols-1 md:gap-4 sb-body">
        You can now donate your rewards points to your favorite charity.
        
        {/* Message Display */}
        {message.text && (
            <div className={`p-4 mb-4 rounded-lg ${
                message.type === 'success'
                    ? 'bg-green-100 text-green-700 border border-green-400'
                    : 'bg-red-100 text-red-700 border border-red-400'
            }`}>
                {message.text === '503'
                    ? 'The donation could not be completed at this time, please try again later.'
                    : message.text
                }
                {isSubmitted && (
                    <div className="mt-4 ctr">
                        <button
                            onClick={handleReset}
                            className="mt-2 inline-block bg-blue-600 border border-transparent rounded-full py-1 px-6 text-sm font-bold text-white text-center hover:bg-blue-700"
                        >
                            Make Another Donation
                        </button>
                    </div>
                )}
            </div>
        )}
        {isSubmitted && (
            <div className="mt-2 text-center">
                <button
                    onClick={() => navigate('/')}
                    className="mt-2 inline-block bg-blue-600 border border-transparent rounded-full py-1 px-6 text-sm font-bold text-white text-center hover:bg-blue-700"
                >
                    Return to Rewards Dashboard
                </button>
            </div>
        )}

        {!isSubmitted && (
            <div className="bg-gray-100 rounded-lg shadow-md p-6">
                <form className="space-y-4" onSubmit={handleSubmit}>
                    <div>
                        <label htmlFor="dropdown" className="block text-sm font-medium text-gray-700 mb-1">
                            Charity to Donate
                        </label>
                        <select
                            id="dropdown"
                            value={selectedCharity}
                            onChange={(e) => setSelectedCharity(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="">Select an option</option>
                            {Object.entries(charityData.charity_list)
                                .filter(([_, itemData]) => itemData.active === 'Y')
                                .map(([itemKey, itemData]) => (
                                    <option key={itemData.id} value={itemData.id}>{itemData.name}</option>
                                ))
                            }
                        </select>
                    </div>

                    <div>
                        <label htmlFor="txtPoints" className="block text-sm font-medium text-gray-700 mb-1">
                            Enter the Number of Points to Donate
                        </label>
                        <input
                            type="text"
                            id="txtPoints"
                            value={points}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '');
                                const numValue = parseInt(value) || 0;

                                const maxPoints = parseFloat(charityData.available_pts.replace(/,/g, '')) || 0;

                                if (numValue <= maxPoints) {
                                    setPoints(value);
                                }
                            }}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder={`Maximum points available: ${charityData.available_pts}`}
                        />
                        <p className="text-xs text-gray-500 mt-1">Minimum donation is 500 points.</p>
                    </div>

                    {isFormValid() && (
                        <div className="ctr">
                            <button
                                type="submit"
                                className="mt-2 inline-block bg-blue-600 border border-transparent rounded-full py-1 px-6 text-sm font-bold text-white text-center hover:bg-blue-700"
                            >
                                Submit
                            </button>
                        </div>
                    )}
                </form>
            </div>
        )}
        {!isSubmitted && (
            <div className="mt-4 text-center">
                <button
                    onClick={() => navigate('/')}
                    className="mt-2 inline-block bg-blue-600 border border-transparent rounded-full py-1 px-6 text-sm font-bold text-white text-center hover:bg-blue-700"
                >
                    Return to Rewards Dashboard
                </button>
            </div>
        )}
      </div>
      </div>
    </div>
  );
}

export default DonateCharityList;